import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchTopWorkspaceAssignmentCreatorsParams {
  days_ago: number;
  limit?: number;
}

interface TopWorkspaceAssignmentCreator {
  user_id: string;
  assignments_count: string;
}

export interface IFetchTopWorkspaceAssignmentCreatorsResponse {
  top_workspace_assignment_creators: Array<TopWorkspaceAssignmentCreator>;
}

export default function useFetchTopWorkspaceAssignmentCreators({
  days_ago,
  limit = 9,
}: IFetchTopWorkspaceAssignmentCreatorsParams): UseQueryResult<
  IFetchTopWorkspaceAssignmentCreatorsResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchTopWorkspaceAssignmentCreatorsResponse>(
    ["top-workspace-assignment-creators", { days_ago, limit }],
    async (): Promise<IFetchTopWorkspaceAssignmentCreatorsResponse> => {
      return await axios
        .get(`/v1/workspaces/assignments/top-creators`, {
          params: {
            days_ago,
            limit,
          },
        })
        .then((r) => {
          return r.data as IFetchTopWorkspaceAssignmentCreatorsResponse;
        });
    }
  );

  return query;
}
